import { useContext, useEffect, useState } from "react";
import { RECENT_ADS, fetchData } from "../../../components/Service";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../../components/Context";
import _ from "lodash";

const RecentAds = (props) => {
	const [list, setList] = useState([]);
	const [context] = useContext(Context);

	const getForum = (country_id, state_id) => {
		let payload = {
			country_id: country_id,
			state_id: state_id,
		};
		fetchData(RECENT_ADS, "POST", payload, false, false, (res) => {
			if (res.status) {
				setList(res?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		if (context?.countryId && context?.stateId) {
			getForum(context?.countryId, context?.stateId);
		}
	}, [context]);

	const showFreeAdsCat = () => {
		if (context?.userToken) {
			window.$(`#freeAdsCatModelSelect`).modal("show");
		} else {
			window.$("#loginModal").modal("show");
		}
	};
	return (
		<div className="col-xl-4 col-lg-4 mb-1">
			<div className="card card-forum h-100">
				<div className="card-header usa-bg">
					<div className="national-bg">
						<div className="row ind1">
							<div className="col-sm-4">
								<h4 className="text-white d-flex ind1">Recent Ads</h4>
							</div>
							<div className="col-sm-8 text-end">
								<span className="font16 fw-normal ms-auto">
									<a href="#!" onClick={showFreeAdsCat} className="text-decoration-underline font11 text-white fw-bold">
										{" "}
										Create Free Ads
									</a>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white news_scroll p-1">
					<div className="table-responsive fixtable">
						<table className="table table-borderless table-sm align-middle ">
							<tbody>
								{list?.slice(0, 10)?.map((item) => (
									<tr key={item.id}>
										<td>
											<Link to={`/classifieds/details/${item.id}`}>{_.truncate(item.title, { length: 70 })}</Link>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div className="card-footer text-end py-1">
					<span className="font16 fw-normal ms-auto">
						<Link to={`/classifieds`} className="text-decoration-underline font11">
							{" "}
							View More
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default RecentAds;
